import ReportIframeViewer from './ReportComponent';

export { default as buildReportUrl } from './processUrl';
// export {default as *} from './Comp1.jsx';

export default ReportIframeViewer;
